import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Paper, Skeleton, Typography } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { TableColumn } from '../../../components/DataTable/TableColumn';
import { Order } from '../../../interfaces/Order/Order';
import { TextColumn } from '../../../components/DataTable/TextColumn';
import { PriceColumn } from '../../../components/DataTable/PriceColumn';
import { DataTable } from '../../../components/DataTable/DataTable';
import { PaginatedResponse } from '../../../interfaces/PaginatedResponse';

import { getOrders } from '../../../api/Order';

const columns: TableColumn<Order>[] = [
  {
    id: 'id',
    name: 'ID',
    accessor: (row) => <TextColumn value={row.id.toString()} />,
  },
  {
    id: 'customer',
    name: 'Alıcı',
    accessor: (row) => (
      <TextColumn value={`${row.customerFirstName} ${row.customerLastName}`} />
    ),
  },
  {
    id: 'status',
    name: 'Durum',
    accessor: (row) => <TextColumn value={row.statusFormatted} />,
  },
  {
    id: 'total',
    name: 'Tutar',
    accessor: (row) => <PriceColumn value={row.totalAmount} />,
  },
];

type OrdersWidgetTableProps = {
  orders: Order[];
  totalCount: number;
};

const OrdersWidgetTable = (props: OrdersWidgetTableProps) => {
  const navigate = useNavigate();

  return (
    <DataTable
      columns={columns}
      totalCount={props.totalCount}
      rows={props.orders}
      onClick={(order) => navigate(`/sales/orders/${order.id}`)}
      hidePagination
      headless
    />
  );
};

const pagination = { page: 0, pageSize: 5 };

export const OrdersWidget = () => {
  const [orders, setOrders] = useState<PaginatedResponse<Order>>({
    data: [],
    totalCount: 0,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getOrders({ pagination })
      .then((o) => setOrders(o))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Paper
      sx={{ display: 'flex', flexDirection: 'column', py: 3, px: 2, gap: 1.5 }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 1.5,
        }}
      >
        <ShoppingCartIcon />

        <Typography variant='h6'>Son Siparişler</Typography>
      </Box>

      {loading ? (
        <Skeleton variant='rectangular' height={200} width='100%' />
      ) : (
        <OrdersWidgetTable
          orders={orders.data}
          totalCount={orders.totalCount}
        />
      )}
    </Paper>
  );
};
